export type ChosenDepartureDate = 'EXACT' | 'FLEXIBLE';
export const CHOSEN_DEPARTURE_DATE = ['EXACT', 'FLEXIBLE'] as const;

export type ChosenDuration = 'WEEKEND' | 'LONG_WEEKEND' | 'WEEK' | 'FORTNIGHT' | 'CUSTOM';

export const CHOSEN_DURATION = ['WEEKEND', 'LONG_WEEKEND', 'WEEK', 'FORTNIGHT', 'CUSTOM'] as const;
